/**
 * Get the summary field for a given key
 *
 * @param {string} key
 * @return {*}
 */
export const getSummaryKey = (key: string): string => {
    const REPLACEABLE_SUMMARY_FIELDS = [
        {
            key: 'store._id',
            value: 'store',
        },
        {
            key: 'stores._id',
            value: 'store',
        },
        {
            key: 'vehicle._id',
            value: 'vehicle',
        },
        {
            key: 'vehicle.make',
            value: 'make',
        },
    ];

    const field = REPLACEABLE_SUMMARY_FIELDS.find((item) => item.key === key);

    return field ? field.value : key;
};
